module.exports = __webpack_public_path__ + "img/83.daff257c.webp";